/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from 'react';
import queryString from 'query-string';

import LoginForm from './LoginForm';
import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';
import logo from './img/logoSumcity.png';
import Helmet from 'react-helmet';
import favicon from './img/favicon.png';

import './style.scss';

class Login extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);
    props.changeDefaultLocale('pt-BR');
  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.body.className = 'sumi-body';
    document.title = 'login';
  }

  render() {
    const { translate } = this.props;

    return (
      <div>
        <Helmet>
          <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        </Helmet>
        <div className="header">
          <img className="logo" src={logo} alt='sumiCity' />
        </div>
        {
          this._validateParams()
            ? <LoginForm
              api={this.api}
              location={this.props.location}
            />
            : <RequestLoginErrorMessage
              onlyMessage={true}
              message={translate('RequestLoginErrorMessage')}
            />
        }
      </div>
    );
  }
}

export default WithLocalize(Login);
